import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import apiClient, { authedFileUrl } from "@/api/client";
import { ArrowLeft, FileText, Download } from "lucide-react";

export default function PortalServiceDetail() {
  const { sid } = useParams(); const nav = useNavigate(); const [data, setData] = useState(null);
  useEffect(() => { apiClient.get(`/portal/services/${sid}`).then(r => setData(r.data)); }, [sid]);
  if (!data) return <div className="text-sm text-[#94A3B8]">Yükleniyor…</div>;
  const s = data.service;
  return (
    <div className="space-y-5" data-testid="portal-service-detail">
      <button onClick={() => nav("/portal/")} className="ky-btn ky-btn-ghost ky-btn-sm"><ArrowLeft size={12}/>Geri</button>
      <div className="ky-card p-6">
        <div className="flex items-center gap-2 mb-2"><span className="ky-badge ky-badge-indigo">{s.service_type}</span><span className={`ky-badge ${s.status==='aktif'?'ky-badge-success':s.status==='tamamlandi'?'ky-badge-neutral':'ky-badge-warning'}`}>{s.status}</span></div>
        <h1 className="text-2xl font-bold">{s.title}</h1>
        {s.deadline && <div className="text-sm text-[#64748B] mt-2">Son teslim: <span className="font-mono">{new Date(s.deadline).toLocaleDateString("tr-TR")}</span></div>}
        <div className="mt-5">
          <div className="flex justify-between text-sm mb-1.5"><span>İlerleme</span><span className="font-semibold">%{s.progress||0}</span></div>
          <div className="h-2 bg-[#F4F4F5] rounded-full overflow-hidden"><div className="h-full bg-gradient-to-r from-[#4F46E5] to-[#7C3AED]" style={{ width: `${s.progress||0}%` }}/></div>
        </div>
        {s.notes && <div className="mt-5 pt-5 border-t border-[#ECECEF]"><div className="text-xs font-semibold uppercase tracking-wider text-[#64748B] mb-2">Notlar</div><div className="text-sm whitespace-pre-wrap">{s.notes}</div></div>}
        {s.type_data && Object.keys(s.type_data).length > 0 && (
          <div className="mt-5 pt-5 border-t border-[#ECECEF]"><div className="text-xs font-semibold uppercase tracking-wider text-[#64748B] mb-3">Hizmet Detayları</div><div className="grid sm:grid-cols-2 gap-3">
            {Object.entries(s.type_data).map(([k,v]) => <div key={k} className="bg-[#FAFAFB] rounded-md p-3"><div className="text-[10px] uppercase font-semibold text-[#94A3B8] tracking-wider">{k.replace(/_/g," ")}</div><div className="text-sm mt-1 font-mono whitespace-pre-wrap break-words">{String(v)}</div></div>)}
          </div></div>
        )}
      </div>

      {data.files.length > 0 && (
        <div className="ky-card p-5">
          <h3 className="font-semibold text-[15px] mb-3">Bu Hizmete Ait Dosyalar ({data.files.length})</h3>
          <div className="grid sm:grid-cols-2 gap-3">
            {data.files.map(f => (
              <a key={f.id} href={authedFileUrl(f.id)} target="_blank" rel="noreferrer" className="ky-card p-3 flex items-center gap-3 ky-card-hover">
                <div className="w-10 h-10 rounded-lg bg-[#EEF2FF] text-[#4F46E5] flex items-center justify-center"><FileText size={16}/></div>
                <div className="flex-1 min-w-0"><div className="text-sm font-medium truncate">{f.original_filename}</div><div className="text-[11px] text-[#94A3B8]">{(f.size/1024).toFixed(1)} KB</div></div>
                <Download size={14} className="text-[#94A3B8]"/>
              </a>
            ))}
          </div>
        </div>
      )}
    </div>
  );
}
